<template>
  <TopNav></TopNav>
  <h1>Exponent Calculator</h1>
  <fieldset>
    <legend>Exponent Calculator</legend>
    <label for="a">Base: </label> <input type="number" v-model.number="base" id="a" step="any" class="blue">
    <br>
    <label for="b">Exponent: </label> <input type="number" v-model.number="exponent" id="b" step="any" class="fuchsia">
    <br><br>
    <span class="blue">{{ baseFormatted }}</span><sup class="fuchsia">{{ exponentFormatted }}</sup> = <span class="green">{{ result() }}</span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Exponent",
  data() {
    return {
      formatter: Intl.NumberFormat('en-US', {
        maximumFractionDigits: 10
      }),
      base: 2,
      baseFormatted: 2,
      exponent: 3,
      exponentFormatted: 3,
    }
  },
  components: {
    TopNav
  },
  methods: {
    result: function () {
      this.baseFormatted = this.formatter.format(this.base);
      this.exponentFormatted = this.formatter.format(this.exponent);

      const result = Math.pow(this.base, this.exponent);
      const resultNumber = Number(result);
      return this.formatter.format(resultNumber);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 110px;
}

.blue {
  color: blue;
}

.green {
    color: green;
}

.fuchsia {
    color: fuchsia;
}

footer section a {
  margin: 20px;
}
</style>
